<template>
  <v-col class="pa-0 pt-5">
    <v-row v-for="(filter, idx) of filters" :key="idx" no-gutters>
      <sidebar-switcher-filter v-bind="filter" />
    </v-row>
  </v-col>
</template>

<script>
import SidebarSwitcherFilter from '@/components/SidebarSwitcherFilter';

export default {
  name: 'SidebarSwitcherFilters',
  components: {
    SidebarSwitcherFilter,
  },
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
